let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Od2P")).then(() => parcelRequire('ljzG9'));